export default __webpack_public_path__ + "static/media/dsv-amazon-heavy-bulky.ec380e3c.svg";